import { useReportError } from "./composables/reportError";

export default defineNuxtPlugin({
  name: "ckweb:sentry:errors",
  dependsOn: ["ckweb:dev-console", "ckweb:sentry"],
  setup(nuxtApp) {
    const { captureException, setContext, logger } = useReportError(nuxtApp);
    const globalNotification = useGlobalNotification();
    nuxtApp.vueApp.config.errorHandler = (error, context) => {
      const err = error as Error;
      const { $options, $attrs, $props } = context ?? {};
      logger.error(logger.fmt`vueApp.errorHandler: ${error}`, { error });
      setContext(
        "context",
        context ? { $options, $attrs, $props } : { unknownContext: true },
      );
      captureException(err);
      globalNotification.showError(`${err}`);
      if (import.meta.env.DEV) {
        devConsole.error(error);
        devConsole.log(context);
      }
    };

    nuxtApp.hook("vue:error", (error, context) => {
      const err = error as Error;
      const { $options, $attrs, $props } = context ?? {};
      logger.error(logger.fmt`vue:error: ${error}`, { error });

      setContext(
        "context",
        context ? { $options, $attrs, $props } : { unknownContext: true },
      );
      captureException(err);
      globalNotification.showError(`${err.message} - ${err.stack!.toString()}`);
      if (import.meta.env.DEV) {
        devConsole.error(error);
        devConsole.log(context);
      }
    });
  },
});
